<section class="content">
    <div class="row header">
        <div class="col-md-4">
            <label class="form-label" for="selectedProject">Project</label>
            <select id="selectedProject" name="selectedProject" class="form-control" [(ngModel)]="selectedProject">
                <option selected="selected" disabled="disabled" [ngValue]="null">--Select the Project--</option>
                <option *ngFor="let project of projects" [ngValue]="project">{{project.name}}</option>
            </select>
        </div>
        <div class="col-md-4">
            <label for="searchTerm" class="form-label">Search</label>
            <div class="row">
                <div class="col-8"><input id="searchTerm" name="searchTerm" [(ngModel)]="term" type="text" class="form-control" /></div>     
                <div class="col"><button type="button" class="btn btn-primary" [class.disabled]="selectedProject == null" [disabled]="selectedProject == null" (click)="search()">Search</button></div>
            </div>
        </div>
    </div>
    <div class="main mt-4 h-100">
        <div class="row h-100 flex-fill">
            <div class="col-6">
                <ag-grid-angular *ngIf="documents.length > 0"
                    class="ag-theme-alpine"
                    [rowData]="documents"
                    [domLayout]="'autoHeight'"
                    [animateRows]="true"
                    [pagination]="true"
                    [columnDefs]="documentSearchColDefs"
                    [gridOptions]="documentSearchGridOptions">
                </ag-grid-angular>
            </div>
            <div class="col" *ngIf="projectId && documentId && projectId != '' && documentId != ''">
                <dexio-document-viewer [projectId]="projectId" [documentId]="documentId"></dexio-document-viewer>
            </div>
        </div>
        <div class="mt-5" *ngIf="documentHistory.length > 0">
            <div class="row mb-3">
                <div class="col">{{documentName}}</div>
                <div class="col">
                    <button *ngIf="unassigning" type="button" class="btn btn-primary disabled" disabled="disabled">Unassigning...</button>
                    <button *ngIf="!unassigning" type="button" class="btn btn-primary" (click)="unassign()">Unassign</button>
                    <button *ngIf="sending" type="button" class="btn btn-primary disabled ms-2" disabled="disabled">Sending...</button>
                    <button *ngIf="!sending" type="button" class="btn btn-primary ms-2" (click)="sendToError()">Send To Issue Resolution</button>
                    <button *ngIf="suppressing" type="button" class="btn btn-primary disabled ms-2" disabled="disabled">Suppressing...</button>
                    <button *ngIf="!suppressing" type="button" class="btn btn-primary ms-2" (click)="suppress()">Suppress</button>
                </div>
            </div>
            <div class="col-12 mt-2">
                <a (click)="showFriendly=false" class="d-inline-block p-2 clickable" [class.active]="!showFriendly">Show Audit</a>
                <a (click)="showFriendly=true" class="d-inline-block p-2 clickable ms-3" [class.active]="showFriendly">Show Friendly</a>
            </div>
            <div class="row col-12" *ngIf="!showFriendly">
                <ag-grid-angular
                    class="ag-theme-alpine"
                    [rowData]="documentHistory"
                    [domLayout]="'autoHeight'"
                    [animateRows]="true"
                    [pagination]="true"
                    [columnDefs]="documentHistoryColDefs"
                    [gridOptions]="documentHistoryGridOptions">
                </ag-grid-angular>
            </div>
            <div class="row col-12" *ngIf="showFriendly">
                <ag-grid-angular
                    class="ag-theme-alpine"
                    [rowData]="friendlyDocumentHistory"
                    [domLayout]="'autoHeight'"
                    [animateRows]="true"
                    [pagination]="true"
                    [columnDefs]="friendlyDocumentHistoryColDefs"
                    [gridOptions]="friendlyDocumentHistoryGridOptions">
                </ag-grid-angular>
            </div>
        </div>
    </div>
</section>
